import "./SpecificationsStandards.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import HubHero from "./sections/HubHero";
import Specifications from "./sections/Specifications";
import RelatedArticles from "./sections/RelatedArticles";
import SupportCta from "./sections/SupportCta";
import Footer from "@/reusable_sections/Footer";
export default function SpecificationsStandardsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="SpecificationsStandards" />
      <HubHero />
      <Specifications />
      <RelatedArticles />
      <SupportCta />
      <Footer />
    </div>;
}